<template>
  <el-form ref="form" :model="form" :rules="rules" class="login-form">
    <img src="../../../../assets/images/login/gjNewLogo.png"
         class="logo-img" alt=""/>
    <div class="title">积加M版</div>
    <div class="f-title">亚马逊卖家精细化运营和管理工具</div>
    <el-form-item prop="username" class="username">
      <el-input
          placeholder="请输入手机号/用户名/邮箱"
          prefix-icon="el-icon-user-solid"
          v-model="form.username"
          @keyup.enter.native="login()">
      </el-input>
    </el-form-item>
    <el-form-item prop="password" class="password">
      <el-input
          ref="pwdInput"
          placeholder="请输入密码"
          :type="isShowPassword?'text':'password'"
          prefix-icon="el-icon-lock"
          v-model="form.password"
          @keyup.enter.native="login()">
          <i slot="suffix"
            :class="[isShowPassword?'iconfont iconnew_bukejian':'iconfont iconnew_kejian']"
            style="font-size:16px; margin-right: 8px;"
            @click="isShowPassword=!isShowPassword" />
      </el-input>
    </el-form-item>
    <el-form-item class="seven-auto-login-item">
      <el-row type="flex" justify="space-between">
        <el-checkbox v-model="form.sevenDaysNoPassword">7天内自动登录</el-checkbox>
        <el-button type="text"  class="dusky-color retrieve-password" style="font-size: 12px; padding: 0; color: #0045F0;" @click="retrievePassword">忘记密码?</el-button>
      </el-row>
    </el-form-item>
    <el-form-item class="login-btn-item">
      <el-button
          class="login-btn"
          type="primary"
          :loading="loading"
          @click="login()">
        登录
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import {USER_LOGIN} from "../../../../store/action-types";
  import {getRegisterInfo, removeRegisterInfo} from "../../../../utils/auth";
  import { tcAuthCodeFreeCheck, isMeaningful, queryParamsMap } from "@/utils/common";

  export default {
    name: "app-account-login",
    data() {
      return {
        form: {
          username: null,
          password: null,
          grantType: 'password',
          loginType: 'WEB',
          sevenDaysNoPassword: false,
          salesCode: null,
          bd_vid: null,
          referer: null
        },
        rules: {
          username: [
            {required: true, message: '请输入用户名', trigger: 'change'}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'change'}
          ]
        },
        formValid: true,
        loading: false,
        isShowPassword: false
      }
    },
    mounted() {
      const registerInfo = getRegisterInfo();
      if (isMeaningful(registerInfo)) {
        this.form.username = registerInfo.phone;
        removeRegisterInfo();
        this.$refs.pwdInput.$refs.input.focus();
      }
    },
    watch: {
      $route: {
        handler: function (route) {
          if (isMeaningful(route.query.salesCode)) {
            this.form.salesCode = route.query.salesCode;
          }
          if (isMeaningful(route.query.bd_vid)) {
            this.form.bd_vid = route.query.bd_vid;
          }
          this.form.referer = route.query.referer;
        },
        immediate: true
      }
    },
    methods: {
      login() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 腾讯图形验证码
          tcAuthCodeFreeCheck(this.form.username).then(resolve => {
            this.loading = true;
            this.$store.dispatch(USER_LOGIN, { ...this.form, code: resolve })
              .then((res) => {
                this.$emit('after-login');
                this.$cacheData.deleteCache()
                this.$gjMessage({
                  message: '登录成功',
                  type: 'success',
                  duration: 1000
                });
              })
              .catch((res) => {
                // this.$gjMessage({
                // message: res.msg || '网络错误，请重试',
                // type: 'error',
                // duration: 3000
                // });
              })
              .complete(() => this.loading = false);
          }).catch(error => {
            // 未验证
          });
          }
        });
      },
      retrievePassword() {
        this.$router.push({path: '/retrieve-password'});
      },
      toRegister() {
        this.$router.push(`/register?${queryParamsMap({
          salesCode: this.form.salesCode,
          bd_vid: this.form.bd_vid || undefined,
          referer: this.form.referer
        })}`);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .logo-img {
    display: none;
  }
  .login-form {
    width: 280px;
  }
  .title {
    font-weight: 600;
    font-size: 24px;
    color: #333333;
    margin-top: 60px;
    margin-bottom: 10px;
  }
  .f-title {
    font-size: 16px;
    color: #999999;
    margin-bottom: 35px;
  }
  /deep/ .el-input__prefix {
    display: none;
  }
  /deep/ .el-form-item__content {
    line-height: 40px;
  }
  /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
    padding: 12px;
  }
  /deep/ .el-input__suffix {
    display: flex;
    align-items: center;
  }
  /deep/ .el-checkbox__label {
    color: #999;
  }
  .login-btn-item {
    margin-top: 40px;
  }
  .login-btn {
    width: 280px;
    height: 40px;
    font-size: 14px;
  }
  .to-register-btn {
    font-size: 12px;
  }
  .seven-auto-login-item {
    width: 100%;
    &/deep/ .el-form-item__content {
      line-height: 20px;
    }
  }
  @media (max-width: 864px) {
    .retrieve-password {
      display: none;
    }
    .login-form {
      width: 72%;
      box-sizing: border-box;
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .logo-img {
      display: inline-block;
      width: 100px;
      margin-top: 64px;
      text-align: center;
    }
    .title {
      font-weight: 600;
      font-size: 34px;
      color: #333333;
      margin-top: 19px;
      margin-bottom: 0;
    }
    .f-title {
      font-size: 16px;
      color: #999999;
      margin-top: 4px;
      margin-bottom: 50px;
    }
    .username,
    .password {
      width: 100%;
    }
    /deep/ .el-input__inner {
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-radius: 0;
      font-size: 17px;
      padding-left: 30px;
    }
    /deep/ .el-input__prefix {
      display: block;
      left: 0;
      font-size: 18px;
    }
    /deep/ .el-form-item {
      margin-bottom: 24px;
    }
    /deep/ .el-checkbox__label {
      color: #999;
      font-size: 15px;
    }
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #999;
    }
    /deep/ .el-checkbox__label:hover,
    /deep/ .el-checkbox__label:focus {
      color: #66b1ff;
    }
    .login-btn-item {
      width: 100%;
      margin-top: 24px;
    }
    .login-btn {
      width: 100%;
      height: 44px;
      background: #0045F0;
      border-radius: 24px;
    }
    .to-register-btn {
      font-size: 15px;
    }
  }
</style>
